

















import Vue from "vue";
import Component from "vue-class-component";
import { LPolyline, LLayerGroup, LMarker, LTooltip } from "vue2-leaflet";
import { LatLng, latLng } from "leaflet";
import GeoUtils from "@/utils/geo_utils";
import { maps, targets } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

@Component<MapMeasurement>({
  components: {
    LPolyline,
    LLayerGroup,
    LMarker,
    LTooltip,
  },
  watch: {
    totalDistance: function(distance) {
      maps.commit(MutationTypes.UPDATE_TOTAL_DISTANCE, distance);
    },
  },
})
export default class MapMeasurement extends Vue {
  markerOptions = { opacity: 0.001, clickable: false };
  //computed
  get pointsArray() {
    let rawPoints = maps.getters.measurementPoints;
    return rawPoints.map(
      (punto): LatLng => {
        let coords, rawTarget;
        if (typeof punto.data === "number") {
          if (punto.tipo === "vessel") {
            rawTarget = targets.getters.searchVesselById(punto.data);
            coords = rawTarget.position.coordinates;
            return latLng(coords[1], coords[0]);
          } else {
            rawTarget = targets.getters.searchSarById(punto.data);
            coords = rawTarget.position.coordinates;
            return latLng(coords[1], coords[0]);
          }
        } else {
          return punto.data;
        }
      }
    );
  }
  get activeMeasurement() {
    return maps.getters.measurementActivated;
  }
  get nauticalUnits() {
    return maps.getters.measurementUnits;
  }
  get pointDistance() {
    interface distanceArrayPoint {
      coords: LatLng;
      distancia: number;
    }
    let previousPoint: LatLng;
    let distanceArray: distanceArrayPoint[] = [];
    this.pointsArray.forEach((punto) => {
      let currentPoint = punto;
      if (previousPoint) {
        let distance = previousPoint.distanceTo(currentPoint);
        distanceArray.push({
          coords: GeoUtils.midpointCalculator(previousPoint, currentPoint),
          distancia: distance,
        });
      }
      previousPoint = currentPoint;
    });
    return distanceArray;
  }
  get totalDistance() {
    let initialDistance = 0;
    this.pointDistance.forEach((punto) => {
      let distancia = this.customMathRound(punto.distancia);
      if (this.nauticalUnits) {
        distancia = this.kmToNm(distancia);
      }
      initialDistance += distancia;
    });
    return initialDistance;
  }

  //methods
  customMathRound(number: number): number {
    return Math.round(number / 10) / 100;
  }
  kmToNm(km: number): number {
    return Math.round(km * 0.539957 * 100) / 100;
  }
  distanceFormat(distance: number): string {
    let distancia = this.customMathRound(distance); //Distancia en kilómetros
    if (this.nauticalUnits) {
      distancia = this.kmToNm(distancia);
      return `${distancia} nm`;
    }
    return `${distancia} km`;
  }
}
